import { Stack } from "@mui/material";
import { Text, Title } from "@src/appV2/redesign/system/ui-components";
import { differenceInSeconds } from "date-fns";

interface PreregistrationCountdownDisplayProps {
  startDate: Date;
  now: Date;
}

export function PreregistrationCountdownDisplay(props: PreregistrationCountdownDisplayProps) {
  const { startDate, now } = props;

  const totalSeconds = Math.max(differenceInSeconds(startDate, now), 0);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const countdown = `${minutes}m ${seconds.toString().padStart(2, "0")}s`;

  return (
    <Stack alignItems="center" justifyContent="center" gap={4} sx={{ width: "100%" }}>
      <Title component="h2" variant="h2" sx={{ textAlign: "center" }}>
        {countdown}
      </Title>
      <Text variant="body1" sx={{ textAlign: "center" }}>
        until scheduled shift start
      </Text>
    </Stack>
  );
}
